var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.717,
    height: 26.717,
    viewBox: "0 0 26.717 26.717",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_482",
    "data-name": "Group 482",
    transform: "translate(3449.851 -1265.779)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_202",
    "data-name": "Path 202",
    d: "M23.164,16.324H18.379V11.539a1.028,1.028,0,0,0-2.055,0v4.785H11.539a.984.984,0,0,0-1.028,1.028,1,1,0,0,0,1.028,1.028h4.785v4.785a1,1,0,0,0,1.028,1.028,1.022,1.022,0,0,0,1.028-1.028V18.379h4.785a1.028,1.028,0,0,0,0-2.055Z",
    transform: "translate(-3453.844 1261.786)",
    fill: "#8da2b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_203",
    "data-name": "Path 203",
    d: "M16.734,5.173A11.556,11.556,0,1,1,8.558,8.558a11.484,11.484,0,0,1,8.176-3.385m0-1.8A13.359,13.359,0,1,0,30.092,16.734,13.357,13.357,0,0,0,16.734,3.375Z",
    transform: "translate(-3453.226 1262.404)",
    fill: "#8da2b7"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.d5a8e7e54c4d63d0a39ceb3e34fffc12.svg";
export { ForwardRef as ReactComponent };